var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10.0001L9.33667 2.53756C9.70333 2.17173 10.2967 2.17173 10.6625 2.53756L18.125 10.0001M3.75 8.12506V16.5626C3.75 17.0801 4.17 17.5001 4.6875 17.5001H8.125V13.4376C8.125 12.9201 8.545 12.5001 9.0625 12.5001H10.9375C11.455 12.5001 11.875 12.9201 11.875 13.4376V17.5001H15.3125C15.83 17.5001 16.25 17.0801 16.25 16.5626V8.12506M6.875 17.5001H13.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHome);
export default __webpack_public_path__ + "static/media/white-home.cc0151af51fb98f446bef3e4ef47307f.svg";
export { ForwardRef as ReactComponent };